import React from 'react';
import { Button, Icon } from 'semantic';
import classNames from 'classnames';
import styles from 'components/modals/RequestCard/typeButton.module.less';

type TypeButtonProps = {
  text: string;
  isSelected: boolean;
  onClick?: () => void;
};

export default function CardStyleRadioButton(props: TypeButtonProps) {
  return (
    <Button
      onClick={props.onClick}
      type="button"
      basic
      style={{ display: 'flex', width: '100%' }}
      color={props.isSelected ? 'blue' : undefined}>
      <Icon
        size="large"
        style={{ width: '1.1rem' }}
        name={props.isSelected ? 'circle-dot regular' : 'circle regular'}
      />
      <p>
        <b>{props.text}</b>
      </p>
    </Button>
  );
}
